<template>
    <v-card flat class="ma-2">
        <v-card-title class="headline primary white--text">
            <v-spacer></v-spacer>
            {{title}}
            <v-icon v-if="animateMode&&target==='end'&&!interval" class="cursor-as-pointer ml-3" @click="play()">fa-play</v-icon>
            <v-icon v-if="animateMode&&target==='end'&&interval" class="cursor-as-pointer ml-3" @click="stop()">fa-stop</v-icon>
        </v-card-title>
        <v-time-picker v-if="time" v-model="time" format="24hr" @change="clockChange" :allowed-minutes="allowedMinutes" light full-width flat
        ></v-time-picker>
    </v-card>
</template>

<script>
import moment from "moment";
import model from "../../views/Model.vue";

export default {
    props: {
        value: {type: Object},
        target: {type: String,default: 'end'},
        title: {type: String,default: 'Time'},
        frameDuration: {type: Number,default: 5000},
        frameMultiplier: {type: Number,default: 1},
        animateMode: {type: Boolean,default: false},
        loop: {type: Boolean,default: false},
    },
    components: {},
    computed: {
        model() {
            return model
        }
    },
    name: 'ClockControlWidget',
    data: function () {
        return {
            interval: null,
            time:null,
            runingDate:null,
            maxDate:null,
        }
    },
    beforeDestroy: function () {
        clearInterval(this.interval)
    },
    watch: {
        value() {
            if (this.value && this.value[this.target] && moment(this.value[this.target]).format("HH:mm") !== this.time) {
                clearInterval(this.interval)
                this.time = moment(this.value[this.target]).format("HH:mm")
            }
        },
    },
    methods: {
        allowedMinutes(v){
            return !(v % (60/this.$store.state.pointsListStore.pointsList.sampling_freq))
        },
        clockChange() {
            let val=JSON.parse(JSON.stringify({
                start:this.value.start,
                end:this.value.end
            }))
            val[this.target]=moment(moment(this.value[this.target]).format("YYYY-MM-DD") + " " + this.time).format('YYYY-MM-DD HH:mm:ss')
            this.$emit('input', val)
        },
        applyFullValue(fullValue) {
            let val=JSON.parse(JSON.stringify({
                start:this.value.start,
                end:this.value.end
            }))
            val[this.target]=fullValue.format('YYYY-MM-DD HH:mm:ss')
            this.$emit('input', val)
        },
        incPlay() {
            if (this.runingDate.isBefore(this.maxDate)) {
                this.runingDate=this.runingDate.add(this.frameMultiplier*60/this.$store.state.pointsListStore.pointsList.sampling_freq, 'minutes')
                this.time = this.runingDate.format("HH:mm")
                this.applyFullValue(this.runingDate)
            } else if (this.loop) {
                this.runingDate =moment(this.value.start)
                this.time = this.runingDate.format("HH:mm")
                this.applyFullValue(this.runingDate)
            } else {
                clearInterval(this.interval)
                this.interval = null
            }
        },
        play() {
            let me = this
            me.runingDate =moment(me.value.start)
            me.maxDate = moment(me.value[me.target])
            me.time = me.runingDate.format("HH:mm")
            me.applyFullValue(me.runingDate)
            me.interval = setInterval(function () {
                me.incPlay()
            }, me.frameDuration);
        },
        stop() {
            clearInterval(this.interval)
            this.interval = null
            this.time = this.maxDate.format("HH:mm")
            this.applyFullValue(this.maxDate)
        },
    }
}

</script>

<style scoped>

</style>
